angular.module('leanlaw').controller('ClientLeanAlign', ['$state', '$stateParams', '$scope', '$http', 'alerts', 'leanLawAuth', 'ModalService', 'userService', '$timeout', function ($state, $stateParams, $scope, $http, alerts, leanLawAuth, ModalService, userService, $timeout) {
  if (!$scope.me.permissions.matters.overview) {
    $state.go('clients.client.view.info', {
      id: $stateParams.id
    });
  }
  $scope.vm = {
    module: $scope.module,
    saving: false,
    originalValue: false,
    loading: true,
    companyAttachReceiptsEnabled: false
  };
  $scope.save = save;
  $scope.cancel = cancel;
  $scope.showSaveCancel = showSaveCancel;
  $scope.toggleAttachReceipts = toggleAttachReceipts;
  activate();
  async function activate() {
    $scope.me = await userService.me();
    $scope.vm.loading = true;
    await fetchInvoiceDeliverySettings();
    if ($scope.vm.module.client) {
      $scope.vm.loading = false;
      $scope.vm.originalValue = $scope.vm.module.client.attachExpenseReceipts;
    } else {
      $scope.$watch('vm.module.client', client => {
        if ($scope.vm.loading && client) {
          $scope.vm.originalValue = !!client.attachExpenseReceipts;
          $scope.vm.loading = false;
        }
      });
    }
  }
  function showSaveCancel() {
    return $scope.vm.originalValue !== $scope.vm.module.client?.attachExpenseReceipts;
  }
  function toggleAttachReceipts() {
    if (!$scope.me.features.expenseAttachments) {
      $scope.vm.module.client.attachExpenseReceipts = $scope.vm.originalValue;
      $timeout(() => {
        $(".modal-backdrop.in").remove();
        // This won't flash because the backdrop is hidden
        // This simply removes the elements so they don't stack up once
        // the body doesn't have the "show-modal-overlay" class
      }, 50);
      ModalService.showModal({
        template: require("./modals/template.html"),
        inputs: {},
        bodyClass: "show-modal-overlay",
        controller: "UpgradeToProExpenseAttachmentsModals"
      }).then(modal => {
        modal.element.modal();
        modal.close.then(result => {
          if (result) {
            $state.go("settings.company.maxioCompanySubscription");
          }
          // Remove modal-open class from body which breaks print
          $("body").removeClass("modal-open");
        });
      });
    }
  }
  async function fetchInvoiceDeliverySettings() {
    $http.get(`${leanLawAuth.domain}/v1/invoicedeliverysettings`).then(result => {
      if (result.status === 200) {
        let modules = result.data.modules;
        let attachmentModule = modules.find(x => x.id === 9);
        if (attachmentModule) {
          $scope.vm.companyAttachReceiptsEnabled = attachmentModule.enabled;
        }
      }
    });
  }
  function cancel() {
    $scope.vm.module.client.attachExpenseReceipts = $scope.vm.originalValue;
  }
  function save() {
    $scope.vm.saving = true;
    $scope.vm.module.client.update().then(() => {
      $scope.vm.originalValue = $scope.vm.module.client.attachExpenseReceipts;
      $scope.vm.saving = false;
      alerts.success('Client details updated!');
    });
  }
}]);